import { Context as AudioContext, Reverb } from 'tone'

export async function createMasterReverb(
  context: AudioContext
): Promise<Reverb> {
  const reverb = new Reverb({ wet: 0.5, context })
  await reverb.generate()
  return reverb
}
